import * as store from '@attain-apps/fe/web/main/lib/store'
import type * as rxjs from 'rxjs'

import type * as ecModels from '../../../models'

import type * as models from './models'
import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ecModels.TypeParams.Constraint,
>() {
  return {
    /**
     * Executes a request against the entity collection's API
     */
    execute: store.actions.request({
      input: <TApiMethodName extends ecModels.Api.Method.Name>(
        request: models.Request<TApiMethodName, TTypeParams>,
      ): typeof request => request,
      output: <TApiMethodName extends ecModels.Api.Method.Name>(
        result: rxjs.ObservedValueOf<
          ecModels.Api.Method.Result<TApiMethodName>
        >,
      ): typeof result => result,
    }),
  } as const satisfies store.actions.Config.Constraint<State<TTypeParams>>
}
